import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Notification {
    id: string;
    title: string;
    body?: string;
    url?: string;
    icon?: string;
    toast?: boolean;
    data?: Record<string, unknown>;
    createdAt: string;
    readAt: string | null;
}

interface NotificationsState {
    list: Notification[];
    unreadCount: number;
    loading: boolean;
}

const initialState: NotificationsState = {
    list: [],
    unreadCount: 0,
    loading: false,
};

const recomputeUnread = (state: NotificationsState) => {
    state.unreadCount = state.list.filter((n) => !n.readAt).length;
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setList(state, action: PayloadAction<Notification[]>) {
            state.list = action.payload;
            recomputeUnread(state);
        },
        pushNew(state, action: PayloadAction<Notification>) {
            const exists = state.list.some((n) => n.id === action.payload.id);
            if (!exists) {
                state.list.unshift(action.payload);
                if (state.list.length > 200) state.list.pop();
                recomputeUnread(state);
            }
        },
        markRead(state, action: PayloadAction<string>) {
            const n = state.list.find((x) => x.id === action.payload);
            if (n && !n.readAt) {
                n.readAt = new Date().toISOString();
                recomputeUnread(state);
            }
        },
        markAllRead(state) {
            const now = new Date().toISOString();
            state.list.forEach((n) => {
                if (!n.readAt) n.readAt = now;
            });
            state.unreadCount = 0;
        },
        clearAll(state) {
            state.list = [];
            state.unreadCount = 0;
        },
    },
});

export const { setLoading, setList, pushNew, markRead, markAllRead, clearAll } = notificationsSlice.actions;
export default notificationsSlice.reducer;
